// ActionType mappings - Mapimi i ActionType-ve me përshkrimet e tyre
export const actionTypeMap = {
  // SHITJE
  IND: "IND - Shitje detale",
  INT: "INT - Shitje total",
  POS: "POS - Shitje P.O.S.",
  ADV: "ADV - Avanci",
  ZRP: "ZRP - Z-Raport",
  DND: "DND - Debit detale",
  // BLERJE
  POT: "POT - Blerje total",
  POD: "POD - Blerje detale",
  IMP: "IMP - Import",
  POF: "POF - Blerje fermeri",
  EXB: "EXB - Shpenzim",
  RNE: "RNE - Qiraja juridike",
  INP: "INP - Investim total",
  IMI: "IMI - Importi investiv",
  // SHËNIME
  CNT: "CNT - Kredit total",
  DNT: "DNT - Debit total",
  CND: "CND - Kredit detale",
  // OPERACIONALE
  WGS: "WGS - Pagë",
  PRD: "PRD - Prodhim", 
  CAD: "CAD - Deponim kapitali",
  REC: "REC - Arkëtim",
  PAY: "PAY - Pagesë",
  RNT: "RNT - Qiraja fizik",
  TRS: "TRS - Transfer",
  // SISTEM
  ACS: "ACS - Fletë kontabël",
  EXS: "EXS - Fletë dalje",
  ENS: "ENS - Flet hyrja",
  // TÉ TJERA
  INS: "INS - Interesi/Provizioni",
  PRI: "PRI - Profaturë",
  OFR: "OFR - Ofertë",
  WDR: "WDR - Tërheqje kapitali",
};

export const getActionTypeLabel = (actionType) => actionTypeMap[actionType] || actionType;